import { render, staticRenderFns } from "./DoctorMngr.vue?vue&type=template&id=54bef392&scoped=true&"
import script from "./DoctorMngr.vue?vue&type=script&lang=js&"
export * from "./DoctorMngr.vue?vue&type=script&lang=js&"
import style0 from "./DoctorMngr.vue?vue&type=style&index=0&id=54bef392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bef392",
  null
  
)

export default component.exports